// src/app/shared/menu.service.ts
import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { MenuItem } from '../../models/menu-item.model';
//import { ApiResponse } from '../models/profile.model';




@Injectable({ providedIn: 'root' })
export class MenuService {
  private extraItemsSubject = new BehaviorSubject<MenuItem[]>([]);
  extraItems$ = this.extraItemsSubject.asObservable();

  setExtraItems(items: MenuItem[]): void {
    this.extraItemsSubject.next(items);
  }

  clearExtraItems(): void {
    this.extraItemsSubject.next([]);
  }
}